import { Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { ExportSelectedRows } from "../ExportCSV";
import filter from "../../assets/images/filter.svg";
import BlueFilterIcon from "../../assets/images/BlueFilterIcon.svg";
import searchMyProjects from "../../assets/images/searchMyProjects.svg";
import searchMyProjectsClicked from "../../assets/images/searchMyProjectsClicked.svg";
import circularRightArrow from "../../assets/images/arrow_circle_right.svg";
import CommonAutocomplete from "../../Utils/CommonAutocomplete";
import { updateuserBU } from "../../store/actions/UserDetailsActions";
import { getSelectedBuList } from "../../service/DashboardService";
import { useDispatch } from "react-redux";
import { ToggleButton } from "../common/ToggleButton/ToggleButton";

const DSBPScreenListHeader = ({
  isSearch = false,
  header,
  allData,
  headers,
  selected,
  filename,
  setVisible,
  actionFlag,
  filterFLag,
  clearFilters,
  expandedKeys,
  // exportCSV,
  onSearchClick,
  isResetEnabled,
  // saveSettings,
  isFilterEnabled,
  isTreeTableFlag,
  projectPlanView,
  // exportCSVTasks,
  CustomizeViewFlag,
  ResetToDefaultFlag,
  handleExapandCollapseAllButton,
  onChildClick,
  clearFiltersResetToDefault,
  buRegionList,
  buRegionValue,
  setBuRegionValue,
  validBu,
  allocation,
  setAllocation
}) => {
  let modifiedAllData = allData;
  const location = useLocation();
  const disPatch = useDispatch();
  const [loading, setLoading] = useState(false);

  if (isTreeTableFlag) {
    modifiedAllData = allData?.map((obj) => obj.data);
  }
  
  const [isClicked, setIsClicked] = useState(isSearch);
  const [isfilterClicked, setIsFilterClicked] = useState(false);

  const handleClick = () => {
    const newIsClicked = !isClicked;
    setIsClicked(newIsClicked);
    onSearchClick();
    if (onChildClick) {
      onChildClick(newIsClicked);
    }
  };
  const handleClearFilter = () => {
    const newIsClicked = !isFilterEnabled;
    setIsClicked(newIsClicked);
    setIsFilterClicked(newIsClicked);
    if (onChildClick) {
      onChildClick(newIsClicked);
    }
  };

  useEffect(() => {
    if (loading) {
      setLoading(false);
      handleExapandCollapseAllButton();
    }
  }, [loading]);

  const applyBuRegion = () => {
    const selectedBu = getSelectedBuList(validBu, buRegionValue);
    disPatch(updateuserBU({ bu: selectedBu, dropdownValue: buRegionValue }));
  };

  return (
    <div className="actions mb-4" style={{ paddingRight: 5 }}>
      <div className="DSBP-heading-container">
        <div className="project-title">{header}</div>
        {buRegionList?.length && buRegionList?.length > 1 && (
          <div className="bu-dropdown-container">
            <div className="dropdown-container">
              <CommonAutocomplete
                suggestions={buRegionList}
                value={buRegionValue}
                optionLabel="buRegionList"
                placeholder="Select BU-Region"
                onChange={(e) => {
                  setBuRegionValue(e?.target?.value);
                }}
                field="label"
              />
            </div>
            <div
              disabled={!buRegionValue}
              onClick={buRegionValue ? applyBuRegion : null}
              className={
                buRegionValue
                  ? "circularRightArrow pointer"
                  : "circularRightArrow circularRightArrowDisable pointer"
              }
            >
              <img src={circularRightArrow} alt="circularRightArrow" />
            </div>
          </div>
        )}
        <div className="toggle-btn">
          <ToggleButton
            classname={"toggle-btn-allocated " + (allocation ? "active" : "deactive")}
            title="Allocated"
            onClick={() => setAllocation(true)}
          />
          <ToggleButton
            classname={"toggle-btn-unallocated " + (!allocation ? "active" : "deactive")}
            title="Unallocated"
            onClick={() => setAllocation(false)}
          />
        </div>
      </div>

      <div className="action-buttons">
        <img
          alt="filter"
          hidden={filterFLag}
          onClick={isFilterEnabled ? handleClearFilter : undefined}
          className={isFilterEnabled ? "header-icons" : ""}
          src={isFilterEnabled ? BlueFilterIcon : filter}
        />
        <img
          src={isClicked ? searchMyProjects : searchMyProjectsClicked}
          alt="search"
          onClick={handleClick}
          className="header-icons"
        />
        
          <>
            <ExportSelectedRows
              headers={headers}
              filename={filename}
              selectedRows={selected}
              allData={modifiedAllData}
            />
            <Button
              variant="secondary"
              className="button-layout"
              hidden={CustomizeViewFlag}
              onClick={() => setVisible(true)}
            >
              Customize View
            </Button>
            <button
              type="button"
              onClick={() => {
                setIsClicked(false)
                clearFiltersResetToDefault("globalReset"); // this button is only present in my projects and all projects pages //AWM-2805
              }}
              disabled={!isResetEnabled}
              hidden={ResetToDefaultFlag}
              className={
                isResetEnabled ? "btn btn-primary reset-to-default-view" : "btn btn-disabled"
              }
            >
              Reset to Default
            </button> 
          </>
        
       </div>
    </div>
  );
};

export default DSBPScreenListHeader;
